import { render, staticRenderFns } from "./PrizeDrawComponent.vue?vue&type=template&id=fb2c86f6&scoped=true"
import script from "./PrizeDrawComponent.vue?vue&type=script&lang=js"
export * from "./PrizeDrawComponent.vue?vue&type=script&lang=js"
import style0 from "./PrizeDrawComponent.vue?vue&type=style&index=0&id=fb2c86f6&prod&lang=css"
import style1 from "./PrizeDrawComponent.vue?vue&type=style&index=1&id=fb2c86f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2c86f6",
  null
  
)

export default component.exports